// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PageLoader_overlay__hGs5A","loader":"PageLoader_loader__ID5TY","bounce-in":"PageLoader_bounce-in__yE4gx","bounce":"PageLoader_bounce__LOPgJ"};